"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HBColorPickerWithHoc = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactColor = require("react-color");
var _common = require("react-color/lib/components/common");
var _HBColorPicker = require("./HBColorPicker.styles");
var _ColorCircleBlock = _interopRequireDefault(require("./ColorCircleBlock"));
var _ColorPickerCircles = _interopRequireDefault(require("./ColorPickerCircles"));
var _useColorPickerConverter = _interopRequireWildcard(require("./useColorPickerConverter"));
var _color = require("../../utils/color.utils");
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _HBColorPickerDrawerControls = _interopRequireDefault(require("./HBColorPickerDrawer/HBColorPickerDrawerControls"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBColorPickerContent = function HBColorPickerContent(_ref) {
  var _selectedColor$rgb;
  var disableAlpha = _ref.disableAlpha,
    presetColors = _ref.presetColors,
    className = _ref.className,
    selectedColor = _ref.selectedColor,
    onChange = _ref.onChange,
    onSaveClicked = _ref.onSaveClicked,
    onCancelClicked = _ref.onCancelClicked,
    removeTransparent = _ref.removeTransparent,
    _ref$presetColorsTitl = _ref.presetColorsTitle,
    presetColorsTitle = _ref$presetColorsTitl === void 0 ? 'Theme Colors' : _ref$presetColorsTitl,
    stopPropagationOnColorPickerClick = _ref.stopPropagationOnColorPickerClick,
    _ref$showInDrawer = _ref.showInDrawer,
    showInDrawer = _ref$showInDrawer === void 0 ? false : _ref$showInDrawer;
  var onColorTextChange = function onColorTextChange(e) {
    var color = e.hex.toLowerCase();
    if (disableAlpha ? (0, _color.isOpaque)(color) : (0, _color.isValidColor)(color)) {
      onChange((0, _useColorPickerConverter.stringToColorResult)(color));
    }
  };
  var onColorSelectChange = function onColorSelectChange(color) {
    if (color.a === 0 || color.h === 0) {
      // check if color is hsl or hsv
      if (color.hasOwnProperty('h') && color.hasOwnProperty('s') && color.hasOwnProperty('l')) {
        var hsv = (0, _useColorPickerConverter.hsl2hsv)(color.h, 100, 50);
        onChange(hsv);
      } else {
        // eslint-disable-next-line no-param-reassign
        color.a = 1;
        onChange(color);
      }
    } else {
      onChange(color);
    }
  };
  var onColorPickerClick = function onColorPickerClick(event) {
    if (stopPropagationOnColorPickerClick) {
      event.stopPropagation();
    }
  };
  if (showInDrawer) {
    return /*#__PURE__*/_react["default"].createElement(_HBColorPickerDrawerControls["default"], {
      onColorChange: onColorSelectChange,
      onColorTextChange: onColorTextChange,
      selectedColor: selectedColor
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_HBColorPicker.ColorPickerWrapper, {
    className: className,
    onClick: onColorPickerClick
  }, /*#__PURE__*/_react["default"].createElement(_HBColorPicker.SaturationWrapper, null, /*#__PURE__*/_react["default"].createElement(_common.Saturation, {
    color: selectedColor.hsl
    // @ts-ignore
    ,
    hsl: selectedColor.hsl
    // @ts-ignore
    ,
    pointer: _HBColorPicker.SaturationPicker,
    style: {
      pointer: {
        position: 'absolute',
        top: "".concat(100 - selectedColor.hsv.v, "%"),
        left: "".concat(selectedColor.hsv.s, "%"),
        cursor: 'pointer',
        transform: 'translate(-50%, -50%)'
      }
    },
    hsv: selectedColor.hsv,
    onChange: onColorSelectChange
  })), /*#__PURE__*/_react["default"].createElement(_HBColorPicker.ControlersWrapper, null, /*#__PURE__*/_react["default"].createElement(_HBColorPicker.ColorControls, null, /*#__PURE__*/_react["default"].createElement(_ColorCircleBlock["default"], {
    color: selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.rgb,
    alpha: selectedColor === null || selectedColor === void 0 || (_selectedColor$rgb = selectedColor.rgb) === null || _selectedColor$rgb === void 0 ? void 0 : _selectedColor$rgb.a
  }), /*#__PURE__*/_react["default"].createElement(_HBColorPicker.HueAlphaWrapper, null, /*#__PURE__*/_react["default"].createElement(_HBColorPicker.HueWrapper, null, /*#__PURE__*/_react["default"].createElement(_common.Hue, (0, _extends2["default"])({}, selectedColor, {
    onChange: onColorSelectChange,
    pointer: _HBColorPicker.CustomPointer
  }))), !disableAlpha && /*#__PURE__*/_react["default"].createElement(_HBColorPicker.AlphaWrapper, null, /*#__PURE__*/_react["default"].createElement(_common.Alpha, (0, _extends2["default"])({}, selectedColor, {
    onChange: onChange,
    pointer: _HBColorPicker.CustomPointer
  }))))), /*#__PURE__*/_react["default"].createElement(_HBColorPicker.EditableInputWrapper, null, /*#__PURE__*/_react["default"].createElement(_common.EditableInput, {
    label: "hex",
    onChange: onColorTextChange,
    value: selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.hex
  })), /*#__PURE__*/_react["default"].createElement(_HBColorPicker.CircleWrapper, null, /*#__PURE__*/_react["default"].createElement(_HBColorPicker.Label, null, presetColorsTitle), /*#__PURE__*/_react["default"].createElement(_ColorPickerCircles["default"], {
    presetColors: presetColors,
    selectedColor: selectedColor,
    onChange: onChange,
    removeTransparent: removeTransparent
  })), !!onSaveClicked && !!onCancelClicked && /*#__PURE__*/_react["default"].createElement(_HBColorPicker.ColorPickerActionsContainer, null, /*#__PURE__*/_react["default"].createElement(_HBButton["default"], {
    fullWidth: true,
    size: "xs",
    testIdName: "cancel",
    buttonTheme: "secondary-solid-primary",
    onClick: onCancelClicked
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_HBButton["default"], {
    fullWidth: true,
    size: "xs",
    testIdName: "save",
    buttonTheme: "primary",
    onClick: onSaveClicked
  }, "Save"))));
};
var HBColorPickerWithHoc = exports.HBColorPickerWithHoc = (0, _reactColor.CustomPicker)(HBColorPickerContent);
var HBColorPicker = exports["default"] = function HBColorPicker(_ref2) {
  var disableAlpha = _ref2.disableAlpha,
    presetColors = _ref2.presetColors,
    selectedColor = _ref2.selectedColor,
    onChange = _ref2.onChange,
    removeTransparent = _ref2.removeTransparent,
    presetColorsTitle = _ref2.presetColorsTitle,
    showInDrawer = _ref2.showInDrawer;
  var _useColorPickerConver = (0, _useColorPickerConverter["default"])(selectedColor, onChange),
    _onChange = _useColorPickerConver.onChange,
    color = _useColorPickerConver.color;
  return /*#__PURE__*/_react["default"].createElement(HBColorPickerWithHoc, {
    onChange: _onChange,
    selectedColor: color,
    disableAlpha: disableAlpha,
    removeTransparent: removeTransparent,
    presetColors: presetColors,
    presetColorsTitle: presetColorsTitle,
    showInDrawer: showInDrawer
  });
};
//# sourceMappingURL=HBColorPicker.js.map